export const COLORS = {
  EXCEL: '#18673b',
  EXCEL_HOVER: '#145a32',
  SCANNER: '#d81b60',
  SCANNER_HOVER: '#b71757',
  SUCCESS: '#10b981',
  SUCCESS_HOVER: '#059669',
  SUCCESS_BG: '#f0fdf4',
  BORDER_DEFAULT: '#e5e7eb',
  BORDER_DRAGOVER: '#6366f1',
  BORDER_HEADER: '#f3f4f6',
  TEXT_PRIMARY: '#1f2937',
  TEXT_SECONDARY: '#6b7280',
  TEXT_MUTED: '#9ca3af',
  TEXT_DIVIDER: '#d1d5db',
  BG_SUBTLE: '#f3f4f6',
  BG_DRAGOVER: '#f9fafb',
};
